import { cn } from '../../lib/cn';
import type { APIWebhookRow } from '../../enterpriseintegration/framework';

type Props = { endpoints?: APIWebhookRow[] };

export function APIWebhookPlatformPanel({ endpoints = [] }: Props) {
  return (
    <div className="space-y-2">
      {endpoints.map((e) => (
        <div key={e.name} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-sm font-medium">{e.name}</p>
            <p className="text-xs text-slate-500">{e.feature}</p>
          </div>
          <div className="text-right">
            <p className="text-xs text-slate-500">{e.calls}</p>
            <span className={cn(
              'text-xs font-medium',
              e.status === 'healthy' || e.status === 'enforced' || e.status === 'active'
                ? 'text-success-600' : 'text-slate-500',
            )}>
              {e.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
